
  <div class="acs-codes">
    @if (isLoading()) {
      <div class="loading-overlay">
        <app-loading-spinner/>
      </div>
    } @else {
      <div class="course-buttons">
        <button class="btn btn-primary mx-2 p-2"
          (click)="getAcsCodes(course.webAppId)"
          *ngFor="let course of courses"
          [ngClass]="{'btn-primary': activeCourse === course.webAppId, 'btn-outline-primary': activeCourse !== course.webAppId}"
        >
          {{course.name}}
        </button>
      </div>
      <div>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col">ACS Code</th>
              <th scole="col">Knowledge</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let category of groupedAcsCodes">
              <tr>
                <td colspan="2" class="category">
                  <din class="text-size-16 font-weight-bold">{{category.key}} - TASK: {{ category.value[0]?.categoryDescription }}</din>
                </td>
              </tr>
              <ng-container *ngFor="let acsCode of category.value">
                <tr>
                  <td>{{ acsCode.code }}</td>
                  <td>{{ acsCode.description }}</td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
  }
  </div>

